import { assetProxyDownloadUrl } from '@opallabs/routing'

type DownloadAssetOptions = {
  filename: string
  uuid: string
}

export const downloadAsset = ({ filename, uuid }: DownloadAssetOptions) => {
  const link = document.createElement('a')

  link.className = 'asset-proxy-download-link'
  link.setAttribute('href', assetProxyDownloadUrl({ uuid }))
  link.setAttribute('download', filename)
  link.setAttribute('target', '_blank')
  link.setAttribute('rel', 'noopener noreferrer')
  link.style.display = 'none'

  // Several browsers require a link to be in the DOM before it can be clicked
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
